export default __webpack_public_path__ + "static/media/mysql.c60e15e1.png";